// extracted by mini-css-extract-plugin
module.exports = {"icon":"styles_icon__qKJ9z","fileTableIcon":"styles_fileTableIcon__gxiHz","fadeInOut":"styles_fadeInOut__3vaIT","loader":"styles_loader__Mnab5"};